import React, { useContext } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import classnames from 'classnames';

// Context
import MobileContext from 'Shared/contexts/MobileContext';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';
import { useResponsiveScreenWidth } from 'Wpds/hooks/useResponsiveScreenWidth';
import { useOrganization } from 'Shared/utils/hooks/use-organization';

// Components
import { Portal } from 'Wpds/components/portal/Portal';
import WorkspaceContent from './WorkspaceContent/WorkspaceContent';
import WorkspaceChooseTemplateSection from './WorkspaceContent/WorkspaceChooseTemplateSection/WorkspaceChooseTemplateSection';
import StartMeetingModeButton from '../../partials/StartMeetingModeButton/StartMeetingModeButton';
import AgendaAiAnnoucement from './AgendaAiAnnoucement/AgendaAiAnnoucement';
import WorkspaceUserBaSnapshot from './WorkspaceUserBaSnapshot/WorkspaceUserBaSnapshot';

// Styles
import './WorkspaceHomeTab.scss';

const WorkspaceHomeTab = () => {
  const { isXtraLarge } = useResponsiveScreenWidth({ isAtLeast: true });
  const { workspaceTemplates, featureFlagShowBaInfoInUserProfile: ffShowBa } = useFlags();
  const { isZoom } = useApp();
  const { workspace } = useWorkspace();
  const { isPiOrganization } = useOrganization();

  const isMobile = useContext(MobileContext);
  const { initialTemplateSelectionMade, isGroup, isPersonal, meeting_items, discussion_topics } = workspace;
  const anyMeetingItemsPresent = meeting_items?.length || discussion_topics?.length;

  const showChooseTemplateSection =
    !isZoom && workspaceTemplates && !initialTemplateSelectionMade && !isPersonal && !anyMeetingItemsPresent;

  const showBaSnapshot = !isZoom && ffShowBa && isPiOrganization && (workspace.isOneOnOne || workspace.isPersonal);

  if (showChooseTemplateSection) return <WorkspaceChooseTemplateSection isGroup={isGroup} />;

  const baseClassName = 'WorkspaceHomeTab';
  const classes = classnames(baseClassName, { [`${baseClassName}--large`]: isXtraLarge });

  return (
    <div className={classes}>
      {isXtraLarge && <AgendaAiAnnoucement />}
      {showBaSnapshot ? (
        <div className={`${baseClassName}__content-wrapper`}>
          <div className={`${baseClassName}__content-wrapper__content`}>
            <WorkspaceContent />
          </div>
          <div className={`${baseClassName}__content-wrapper__ba-snapshot`}>
            <WorkspaceUserBaSnapshot view={isXtraLarge ? 'side-rail' : 'on-top'} />
          </div>
        </div>
      ) : (
        <WorkspaceContent />
      )}
      {isZoom && isMobile && (
        <Portal idPrefix="zoom-start-meeting-mode-button">
          <StartMeetingModeButton />
        </Portal>
      )}
    </div>
  );
};

export default WorkspaceHomeTab;
